import { bindable, inject } from 'aurelia-framework';
import * as moment from 'moment';
import 'moment-timezone';
import { defineCustomElements } from '@duetds/date-picker/dist/loader';

/**
 * Wrapper class for duet-date-picker (@duetds/date-picker).
 * This datepicker is accessibility compliant and functions as a drop-in
 * replacement for the old JQueryUI datepicker.
 */
@inject(Element)
export class DuetDatePicker {
	readonly element: HTMLDuetDatePickerElement;
	@bindable min: number;
	@bindable max: number;
	@bindable businessTimezone: string;
	@bindable selectedDate: string;
	@bindable selectedFunction;

	constructor(element) {
		this.element = element;
	}

	attached() {
		defineCustomElements(this.element as any); // injects picker

		let min: number = 0;
		if (this.min !== undefined) {
			min = this.min;
		}

		let max: number = 3650;
		if (this.max !== undefined) {
			max = this.max;
		}

		let startDate = moment(this.businessTimezone ? moment.tz(this.businessTimezone).format('MM/DD/YYYY') : new Date()).add(min, 'days').format('YYYY-MM-DD');
		let endDate = moment(this.businessTimezone ? moment.tz(this.businessTimezone).format('MM/DD/YYYY') : new Date()).add(max, 'days').format('YYYY-MM-DD');
		this.element.min = startDate;
		this.element.max = endDate;

		this.element.dateAdapter = {
			parse(value = '', createDate) {
				const DATE_FORMAT = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
				const matches = value.match(DATE_FORMAT);
				if (matches) {
					return createDate(matches[3], matches[1], matches[2]);
				}
			},
			format(date) {
				return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
			},
		};

		this.element.addEventListener('duetChange', (e: CustomEvent) => {
			this.selectedDate = moment(e.detail.value).format('MM/DD/YYYY');
		});

		this.element.localization = {
			buttonLabel: 'Choose date',
			placeholder: 'MM/DD/YYYY',
			selectedDateMessage: 'Selected date is',
			prevMonthLabel: 'Previous month',
			nextMonthLabel: 'Next month',
			monthSelectLabel: 'Month',
			yearSelectLabel: 'Year',
			closeLabel: 'Close window',
			calendarHeading: 'Choose a date',
			dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
			monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
			monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
			locale: 'en-us'
		};
	}

	selectedDateChanged(d: string) {
		this.element.value = moment(d).format('YYYY-MM-DD');
		if(this.selectedFunction  && this.element.value !== "Invalid date") {
			this.selectedFunction(this.element.value);
		}
	}
}
